import Channels from "../base/channels";

export default function ResizeDebounce() {
  var windowWidth = window.innerWidth;
  window.addEventListener("resize", function () {
    clearTimeout(window.resizedFinished);
    // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
    if (window.innerWidth != windowWidth) {
      // Update the window width for next time
      windowWidth = window.innerWidth;
      // Do stuff here
      window.resizedFinished = setTimeout(function () {
        Channels.emit("window::smartresize");
      }, 100);
    }
  });
}
